import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;

// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {

//     if (error.response.status === 401) {
//       // Handle Unauthorized error here
//       console.log('auth Unauthorized', error.response);
//       localStorage.removeItem('token');
//     } else {
//       // Handle other errors here

//       console.log('Error:', error.message);
//     }
//     return Promise.reject(error);
//   },
// );


export const addNewTicket = async (data, token) => {
  try {

    return await axios
      .post(`${API}/sendTicket`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};





// Get email recipient ID if exists
const getEmailRecipientId = async (ticketMasterId, email) => {
  try {
    const poolConnect = await pool.connect();
    const request = poolConnect.request();

    const result = await request
      .input('ticketMasterId', sql.Int, ticketMasterId)
      .input('email', sql.NVarChar, email)
      .query(`
        SELECT EmailRecipientId
        FROM EmailRecipients
        WHERE TicketMasterId = @ticketMasterId
        AND Email = @email
        AND IsActive = 1
      `);

    return result.recordset.length > 0 ? result.recordset[0].EmailRecipientId : null;
  } catch (err) {
    console.error('Error getting email recipient ID:', err);
    return null;
  }
};

// Get ticket by ID
const getTicketById = async (ticketMasterId) => {
  try {
    const poolConnect = await pool.connect();
    const request = poolConnect.request();

    const result = await request
      .input('ticketMasterId', sql.Int, ticketMasterId)
      .query(`
        SELECT 
          tm.TicketNo as ticketNo,
          tm.Subject as subject,
          c.CompanyName as companyName,
          tm.CreatedDate as createdDate
        FROM TicketMaster tm
        LEFT JOIN Company c ON tm.CompanyId = c.CompanyId
        WHERE tm.TicketMasterId = @ticketMasterId
      `);

    return result.recordset.length > 0 ? result.recordset[0] : null;
  } catch (err) {
    console.error('Error getting ticket by ID:', err);
    return null;
  }
};

// Get user by ID
const getUserById = async (userId) => {
  try {
    const poolConnect = await pool.connect();
    const request = poolConnect.request();

    const result = await request
      .input('userId', sql.Int, userId)
      .query(`
        SELECT 
          UserId,
          UserName,
          ContactPerson,
          Email
        FROM Users
        WHERE UserId = @userId
      `);

    return result.recordset.length > 0 ? result.recordset[0] : null;
  } catch (err) {
    console.error('Error getting user by ID:', err);
    return null;
  }
};

// Email body for private messages
const generatePrivateMessageEmailBody = (
  recipientName,
  ticketNo,
  subject,
  message,
  companyName,
  senderName,
  sentDate,
  utcOffset
) => {
  const formattedDate = new Date(sentDate).toLocaleString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const htmlBody = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          color: #333;
        }
        .container {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
          background-color: #f9f9f9;
          border: 1px solid #ddd;
          border-radius: 5px;
        }
        .header {
          background-color: #6c757d;
          color: white;
          padding: 15px;
          text-align: center;
          border-radius: 5px 5px 0 0;
        }
        .content {
          background-color: white;
          padding: 20px;
          border-radius: 0 0 5px 5px;
        }
        .ticket-info {
          background-color: #f8f9fa;
          padding: 15px;
          margin: 15px 0;
          border-left: 4px solid #6c757d;
        }
        .ticket-info p {
          margin: 8px 0;
        }
        .label {
          font-weight: bold;
          color: #555;
        }
        .message-box {
          background-color: #fff3cd;
          padding: 15px;
          margin: 15px 0;
          border-radius: 5px;
          border: 1px solid #ffc107;
        }
        .private-badge {
          display: inline-block;
          padding: 5px 15px;
          background-color: #6c757d;
          color: white;
          border-radius: 20px;
          font-weight: bold;
          margin: 10px 0;
        }
        .footer {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #ddd;
          font-size: 12px;
          color: #666;
          text-align: center;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h2>🔒 Private Message</h2>
        </div>
        <div class="content">
          <p>Dear ${recipientName},</p>
          <p>You have received a private message regarding ticket <strong>${ticketNo}</strong>.</p>
          
          <div class="private-badge">
            PRIVATE MESSAGE
          </div>

          <div class="ticket-info">
            <p><span class="label">Ticket Number:</span> ${ticketNo}</p>
            <p><span class="label">Subject:</span> ${subject}</p>
            <p><span class="label">Company:</span> ${companyName || 'N/A'}</p>
            <p><span class="label">From:</span> ${senderName}</p>
            <p><span class="label">Sent:</span> ${formattedDate} (UTC${utcOffset >= 0 ? '+' : ''}${utcOffset})</p>
          </div>

          <div class="message-box">
            <p class="label">Private Message:</p>
            <div>${message}</div>
          </div>

          <p><strong>Note:</strong> This is a private message visible only to selected users.</p>

          <div class="footer">
            <p>This is an automated email. Please do not reply to this message.</p>
            <p>&copy; ${new Date().getFullYear()} Your Company. All rights reserved.</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return htmlBody;
};

// Email body for regular replies
const generateReplyEmailBody = (
  recipientName,
  ticketNo,
  subject,
  reply,
  companyName,
  replyUserName,
  replyDate,
  utcOffset
) => {
  const formattedDate = new Date(replyDate).toLocaleString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const htmlBody = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          color: #333;
        }
        .container {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
          background-color: #f9f9f9;
          border: 1px solid #ddd;
          border-radius: 5px;
        }
        .header {
          background-color: #17a2b8;
          color: white;
          padding: 15px;
          text-align: center;
          border-radius: 5px 5px 0 0;
        }
        .content {
          background-color: white;
          padding: 20px;
          border-radius: 0 0 5px 5px;
        }
        .ticket-info {
          background-color: #f8f9fa;
          padding: 15px;
          margin: 15px 0;
          border-left: 4px solid #17a2b8;
        }
        .ticket-info p {
          margin: 8px 0;
        }
        .label {
          font-weight: bold;
          color: #555;
        }
        .reply-box {
          background-color: #f8f9fa;
          padding: 15px;
          margin: 15px 0;
          border-radius: 5px;
          border: 1px solid #e0e0e0;
        }
        .footer {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #ddd;
          font-size: 12px;
          color: #666;
          text-align: center;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h2>💬 New Reply on Your Ticket</h2>
        </div>
        <div class="content">
          <p>Dear ${recipientName},</p>
          <p>A new reply has been added to your support ticket.</p>

          <div class="ticket-info">
            <p><span class="label">Ticket Number:</span> ${ticketNo}</p>
            <p><span class="label">Subject:</span> ${subject}</p>
            <p><span class="label">Company:</span> ${companyName || 'N/A'}</p>
            <p><span class="label">Replied By:</span> ${replyUserName}</p>
            <p><span class="label">Reply Date:</span> ${formattedDate} (UTC${utcOffset >= 0 ? '+' : ''}${utcOffset})</p>
          </div>

          <div class="reply-box">
            <p class="label">Reply:</p>
            <div>${reply}</div>
          </div>

          <p>Please log in to the support portal to view the complete conversation and respond.</p>

          <div class="footer">
            <p>This is an automated email. Please do not reply to this message.</p>
            <p>&copy; ${new Date().getFullYear()} Your Company. All rights reserved.</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;

  return htmlBody;
};

// Add this function to your functions/ticket.js file

export const addTicketDetail = async (data, token) => {
  try {
    if (!token) {
      console.error('No token provided to addTicketDetail');
      return { data: { error: 'Authentication token is missing' } };
    }

    const response = await axios.post(`${API}/addTicketDetail`, data, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      }
    });

    return response;
  } catch (err) {
    console.error('Error in addTicketDetail:', err);
    return {
      data: {
        error: err.response?.data?.error || err.message || 'Failed to add ticket detail'
      }
    };
  }
};


export const searchTickets = async (data, token) => {
  try {

    return await axios
      .post(`${API}/searchTickets`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const searchTickets_client = async (data, token) => {
  try {

    return await axios
      .post(`${API}/searchTickets_client`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const getPriorities = async () =>
  await axios.get(
    `${API}/getPriorities`,
    {
      headers: {
        // authtoken,
      },
    },
  );

export const getTicketStatus = async () =>
  await axios.get(
    `${API}/getTicketStatus`,
    {
      headers: {
        // authtoken,
      },
    },
  );



export const getTicketMasterCon = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/getTicketMasterCon/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in getTicketMasterCon:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};


export const getTicketMasterDetails = async (ticketMasterId, getLatestDetail, token) => {
  try {

    const data = { ticketMasterId, getLatestDetail };
    return await axios
      .post(`${API}/getTicketMasterDetails/`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in getTicketMasterDetails:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};


export const getTicketMasterDetailsGreaterThanTicketDetailId = async (ticketDetailId, token) => {
  try {

    const data = { ticketDetailId };
    return await axios
      .post(`${API}/getTicketMasterDetailsGreaterThanTicketDetailId/`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in getTicketMasterDetailsGreaterThanTicketDetailId:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};


export const getContactTypes = async () => {
  try {

    return await axios
      .get(`${API}/getContactTypes`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const getAttachmentsByTicketDetailId = async (ticketDetailId, token) => {
  try {

    return await axios
      .get(`${API}/getAttachmentsByTicketDetailId/${ticketDetailId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};



export const checkForNewReply = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/checkForNewReply/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in checkForNewReply:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};

export const ticketAssign = async (data, token) => {
  try {

    return await axios
      .post(`${API}/ticketAssign`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const ticketReject = async (data, token) => {
  try {

    return await axios
      .post(`${API}/ticketReject`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const acceptTicket = async (data, token) => {
  try {
    return await axios
      .post(`${API}/acceptTicket`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const isTicketAccepted = async (ticketMasterId, token) => {
  try {
    const data = { ticketMasterId };
    return await axios
      .post(`${API}/isTicketAccepted`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const closeTicket = async (data, token) => {
  try {
    console.log('closeTicket data :', data);

    return await axios
      .post(`${API}/closeTicket`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const submitFeedback = async (data, token) => {
  try {
    return await axios
      .post(`${API}/submitFeedback`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const isFeedbackSubmitted = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/isFeedbackSubmitted/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in isFeedbackSubmitted:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};



export const isTicketClosed = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/isTicketClosed/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error in isTicketClosed:', err);
        return null;
      });
  } catch (err) {
    return err;
  }
};

export const getTicketStatusByTicketMasterId = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/getTicketStatusByTicketMasterId/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const openTicket = async (data, token) => {
  try {
    return await axios
      .post(`${API}/openTicket`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const markConversationAsSeen = async (data, token) => {
  try {
    console.log('setMarkAsSeen :', data);
    return await axios
      .post(`${API}/markConversationAsSeen`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const ticketSearchByKeywords = async (data, token) => {
  try {
    return await axios
      .post(`${API}/TicketSearchByKeywords`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getUpdatesByTicket = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/getUpdatesByTicket/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};




export const getTicketStatusCount = async (token) => {
  try {

    return await axios
      .get(`${API}/getTicketStatusCount`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const deleteConversationReply = async (ticketDetailId, gmt_Offset, token) => {
  try {
    const data = { ticketDetailId, gmt_Offset }
    return await axios
      .post(`${API}/conversation/delete-conversation-reply`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};




export const getTicketDetailSharedUser = async (ticketDetailId) => {
  try {

    return await axios
      .get(`${API}/getTicketDetailSharedUser/${ticketDetailId}`, {
        headers: {
          'Content-Type': 'application/json'
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const agentFeedbackInertUpdate = async (ticketMasterId, difficulty, impact, remark, token) => {
  try {
    const data = { ticketMasterId, difficulty, impact, remark }
    return await axios
      .post(`${API}/ticket/agentFeedback-inert-update`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};



export const getAgentFeedbacks = async (ticketMasterId, token) => {
  try {

    return await axios
      .get(`${API}/agentFeedback_select/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getTicketRejectStatus = async (ticketMasterId, token) => {
  try {
    return await axios
      .get(`${API}/getTicketRejectStatus/${ticketMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};
